export default "__VITE_ASSET__192fa179__"